import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';
import cx from 'classnames';

const View = ({ data }) => {
  const { subtitle, subtitleLink, align = 'center' } = data;

  const hasLink = subtitleLink?.length > 0;
  const hClass = cx(
    {
      [`text-${align}`]: align,
      'text-interactive': hasLink,
    },
    'section-subtitle',
  );

  return (
    <h3 className={hClass}>
      <ConditionalLink item={subtitleLink?.[0]} condition={hasLink}>
        <MaybeWrap condition={!hasLink} as="span">
          {subtitle}
        </MaybeWrap>
      </ConditionalLink>
    </h3>
  );
};

export default View;
